export default (data) => ({
  type: 'RESET_FILTER',
  payload: data,
});
